"use client";

import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import { generateConnectJwtUrl } from "../../client/manager/cross-posting";
import type { SocialPlatform } from "../../models/ayrshare";

interface GenerateConnectJwtUrlInput {
  comedianId: string;
  platform?: SocialPlatform;
  redirectUrl?: string;
}

/**
 * Generate a fresh Ayrshare-hosted JWT URL to open in a new window.
 *
 * One-shot per D-05 — NO invalidation, NO onSuccess. Consumers grab the URL
 * from .data after the mutation resolves. Pessimistic per D-06.
 */
export function useGenerateConnectJwtUrl(): UseMutationResult<
  string,
  Error,
  GenerateConnectJwtUrlInput,
  unknown
> {
  return useMutation({
    mutationFn: (input: GenerateConnectJwtUrlInput) =>
      generateConnectJwtUrl(
        input.comedianId,
        input.platform,
        input.redirectUrl
      ),
  });
}
